export const RouterHome = [
  {
    path: "/", // 注册 验证码
    name: "首页",
    component: (resolve) => require(/* webpackChunkName: "home" */ ["@/views/home/Index"], resolve),
  },
  {
    path: "/wx", // 注册 验证码
    name: "微信授权",
    component: (resolve) => require(/* webpackChunkName: "home" */ ["@/views/home/Wx"], resolve),

  }
];
